import React, { useState } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Field, Form, Formik } from 'formik';
import {
  checkIfTimeFieldsAreUsed,
  getLabelForNextButton,
  getLabelForPrevButton,
  isMoreThan6Months,
  renderStandardReportFormFields,
  TIME_FROM_FIELD, TIME_TO_FIELD, updateDateRangeFields,
} from './StandardReportUtils';
import { bindActionCreators, compose } from 'redux';
import { fetchStandardReports } from '../../../../actions/report-actions';
import { lighten } from '@material-ui/core/styles';
import { useValidator } from '../../../../utils/validators';
import { getDifferenceInMonthBetweenTwoDates } from '../../../../utils/dates-utils';
import CommonMultiSelectField from '../../../common/form/CommonMultiSelectField';
import withStyles from '@material-ui/core/styles/withStyles';
import LoadingSnackbar from '../../../common/LoadingSnackbar';
import CommonButton from '../../../common/CommonButton';
import CommonDivider from '../../../common/CommonDivider';
import {
  SEARCH_BUTTON_WIDTH,
  STANDARD_INPUT_HEIGHT,
  STANDARD_INPUT_RADIUS,
  STANDARD_INPUT_WIDTH,
  STANDARD_MOBILE_INPUT_HEIGHT,
} from '../../../../const/chart-const';
import {
  ALMOST_BLACK_COLOR,
  ALMOST_WHITE_COLOR,
  BACKGROUND_WHITE, BLACK_COLOR, DARK_BORDER_COLOR, FRESHDESK_GREY, LIGHT_GREY_COLOR,
} from '../../../../const/color-const';
import { TRANSACTION_LIST } from './StandardReportConfig';
import CommonSelectField from '../../../common/form/CommonSelectField';
import {
  DATE_OPTIONS_STANDARD_REPORT, DATE_OPTIONS_STANDARD_REPORT_NEXT_DAY, THIS_MONTH,
} from '../../../../utils/dates-const';
import { fetchBusinessSalesStart } from '../../../../actions/user-actions';
import { CircularProgress } from '@material-ui/core';
import PropTypes from 'prop-types';
import { ArrowLeftIcon } from '@material-ui/pickers/_shared/icons/ArrowLeftIcon';
import classNames from 'classnames';
import { ArrowRightIcon } from '@material-ui/pickers/_shared/icons/ArrowRightIcon';

const styles = theme => ({
  '& form': {
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(1.5),
    '& button': {
      width: SEARCH_BUTTON_WIDTH,
    },
  },
  fieldsWrapper: {
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      alignItems: 'center',
    },
    '& > [class*="MuiTextField"], & [class*="dateTimePickerWrapper"], & [class*="regularTimePickerWrapper"], & [class*="CommonCheckboxWrapper"]': {
      border: theme.palette.type === 'light' ? `1px solid ${LIGHT_GREY_COLOR}` : `1px solid ${DARK_BORDER_COLOR}`,
      '&:hover': {
        border: theme.palette.type === 'light' ? `1px solid ${BLACK_COLOR}` : `1px solid white`,
      },
    },
    '& > div': {
      backgroundColor: theme.palette.type === 'light' ? lighten(BACKGROUND_WHITE, 0.7) : BLACK_COLOR,
      borderRadius: STANDARD_INPUT_RADIUS,
      height: STANDARD_MOBILE_INPUT_HEIGHT,
      marginTop: theme.spacing(1),
      marginLeft: 0,
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      [theme.breakpoints.up('md')]: {
        height: STANDARD_INPUT_HEIGHT,
        width: STANDARD_INPUT_WIDTH,
        margin: theme.spacing(1),
      },
      '& > [class*="MuiTextField"]': {
        '& label:not(.Mui-focused):not([class*="MuiFormLabel-filled"])': {
          marginTop: -10,
        },
        '& [class*="MuiInputAdornment"]': {
          marginBottom: 4,
        },
      },
      '& label': {
        border: 'none',
        marginLeft: 10,
      },
      '& > div': {
        width: '100%',
        '& input': {
          marginLeft: 10,
          border: 'none',
          height: '100%',
          width: '100%',
          padding: 0,
          fontSize: 14,
          [theme.breakpoints.up('md')]: {
            fontSize: 16,
          },
        },
      },
      '& div': {
        '&::before': {
          display: 'none',
        },
        '&::after': {
          display: 'none',
        },
      },
    },
    '& .commonSelectField': {
      [theme.breakpoints.down('sm')]: {
        marginTop: theme.spacing(2),
      },
      '& label': {
        marginLeft: 0,
      },
      '& fieldset': {
        border: theme.palette.type === 'light' ? `1px solid ${LIGHT_GREY_COLOR}` : `1px solid ${DARK_BORDER_COLOR}`,
      },
    },
  },
  rangeButton: {
    border: theme.palette.type === 'light' ? `1px solid ${LIGHT_GREY_COLOR}` : `1px solid ${DARK_BORDER_COLOR}`,
    backgroundColor: theme.palette.type === 'light' ? lighten(BACKGROUND_WHITE, 0.7) : BLACK_COLOR,
    color: theme.palette.type === 'light' ? BLACK_COLOR : ALMOST_WHITE_COLOR,
    borderRadius: STANDARD_INPUT_RADIUS,
    margin: theme.spacing(2),
    height: 48,
    width: '100%',
    padding: 0,
    [theme.breakpoints.up('md')]: {
      width: 160,
      height: STANDARD_INPUT_HEIGHT,
    },
    '&:hover': {
      border: theme.palette.type === 'light' ? `1px solid ${BLACK_COLOR}` : `1px solid white`,
      background: 'none',
      boxShadow: 'none',
    },
    '& > span': {
      justifyContent: 'space-between',
      display: 'flex',
      height: '100%',
      width: '100%',
      padding: 0,
      margin: 0,
      '& span[class*="MuiButton-label"]': {
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
  },
  rangeButtonPrev: {
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(1, 0, 0, 0),
    },
    '& span[class*="MuiButton-label"]': {
      '& span[class*="startIcon"]': {
        margin: 0,
        maxWidth: 36,
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: theme.palette.type === 'light' ? FRESHDESK_GREY : ALMOST_BLACK_COLOR,
      },
    },
  },
  rangeButtonNext: {
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(1, 0, 0, 0),
    },
    '& span[class*="MuiButton-label"]': {
      '& span[class*="endIcon"]': {
        margin: 0,
        maxWidth: 36,
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: theme.palette.type === 'light' ? FRESHDESK_GREY : ALMOST_BLACK_COLOR,
      },
    },
  },
  btnLabel: {
    width: '100%',
  },
  topRow: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: theme.spacing(1),
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
    '& > div': {
      height: 48,
      margin: theme.spacing(1),
      backgroundColor: theme.palette.type === 'light' ? lighten(BACKGROUND_WHITE, 0.7) : BLACK_COLOR,
      [theme.breakpoints.up('md')]: {
        height: 60,
      },
    },
    '& > div[class*="MultiSelectField"]': {
      margin: theme.spacing(1),
    },
  },
});

const validator = ({ values, intl: { formatMessage } }) => {
  const errors = {};
  
  if (!values.dateFrom || !values.dateTo) {
    errors.dateFrom = formatMessage({
      id: 'form.standard.report.date.required',
      defaultMessage: 'Date required',
    });
    errors.dateTo = formatMessage({
      id: 'form.standard.report.date.required',
      defaultMessage: 'Date required',
    });
  } else if (getDifferenceInMonthBetweenTwoDates(new Date(values.dateFrom), new Date(values.dateTo)) > 3) {
    errors.dateFrom = formatMessage({
      id: 'form.standard.report.date.max3.months.date.range',
      defaultMessage: 'Maximum date range is 3 months',
    });
    errors.dateTo = formatMessage({
      id: 'form.standard.report.date.max3.months.date.range',
      defaultMessage: 'Maximum date range is 3 months',
    });
  }
  
  return errors;
};

const getInitialValues = (fields, salesStartTime) => {
  const appliedFields = salesStartTime ? applyBusinessStartTimeAsDefault(fields, salesStartTime) : fields;
  return {
    ...Object.fromEntries(appliedFields.map(value => [value.name, value.initialValue ?? value.initialValue])),
    machineIDs: [null],
    dateRange: THIS_MONTH.value,
  };
};

const applyBusinessStartTimeAsDefault = (fields, salesStartTime) => {
  const { Hour, Minute, Second } = salesStartTime?.salesStartTime || {};
  const timestamp = new Date().setHours(Hour, Minute, Second);
  
  return fields.map(field => ({
    ...field,
    initialValue: [TIME_FROM_FIELD.name, TIME_TO_FIELD.name].includes(field.name) ? timestamp : field.initialValue,
  }));
};

const StandardReportForm = ({
                              fields,
                              fetchStandardReports,
                              setFormValues,
                              machines,
                              classes,
                              reportName,
                              salesStartTime,
                              fetchBusinessSalesStart,
                            }) => {
  const [loadingProgress, setLoadingProgress] = useState();
  const machinesOptions = machines.map(({ Id, Name }) => ({ label: Name, value: Id }));
  const [isLoadingSalesStartTime, setIsLoadingSalesStartTime] = useState(true);
  const [dateRangeValue, setDateRangeValue] = useState(THIS_MONTH.value);
  const removeDateRange = ({ dateRange, ...rest }) => rest;
  const isTimeIncluded = checkIfTimeFieldsAreUsed(fields);
  const formValidator = useValidator(validator);
  
  React.useEffect(() => {
    if (!salesStartTime) {
      fetchBusinessSalesStart();
    }
    setIsLoadingSalesStartTime(false);
  }, [fetchBusinessSalesStart, salesStartTime]);
  
  if (isLoadingSalesStartTime) {
    return <CircularProgress />;
  }
  
  const handleDateRangeChange = (value, validateForm) => {
    setDateRangeValue(value);
    validateForm();
  };
  
  return <Formik
    initialValues={getInitialValues(fields, salesStartTime)}
    onSubmit={(values, formikHelpers) => {
      setFormValues(values);
      fetchStandardReports(reportName, removeDateRange(values), formikHelpers, setLoadingProgress);
    }}
    validate={reportName === TRANSACTION_LIST && TRANSACTION_LIST.reportName && formValidator}>
    {(form) => {
      const { isSubmitting, values, isValid, submitForm, validateForm, setFieldValue } = form;
      return (
        <Form
          className={classes.form}>
          <LoadingSnackbar
            progress={loadingProgress}
            label={<FormattedMessage id="loading" defaultMessage="Loading" />}
            large={isMoreThan6Months(values.dateFrom, values.dateTo)}
          />
          
          <div className={classes.topRow}>
            <Field
              wide
              atLeastOneElement
              name="machineIDs"
              label={<FormattedMessage
                id="field.cash.register"
                defaultMessage="Cash Register"
              />}
              options={[...machinesOptions, {
                label: <>- <FormattedMessage
                  id="all"
                  defaultMessage="All"
                /> -</>, value: null,
              }]}
              component={CommonMultiSelectField}
            />
            
            <Field
              date
              name="dateRange"
              label={<FormattedMessage id="date.field.date.range" defaultMessage="Date range" />}
              options={isTimeIncluded ? DATE_OPTIONS_STANDARD_REPORT_NEXT_DAY : DATE_OPTIONS_STANDARD_REPORT}
              component={CommonSelectField}
              extraHandleChangeAction={(value) => handleDateRangeChange(value, validateForm)}
            />
          </div>
          
          <div className={classes.fieldsWrapper}>
            <CommonButton
              size="large"
              startIcon={<ArrowLeftIcon />}
              label={getLabelForPrevButton(dateRangeValue, classes)}
              className={classNames(classes.rangeButton, classes.rangeButtonPrev)}
              onClick={() => updateDateRangeFields('previous', values, setFieldValue, validateForm, dateRangeValue, isTimeIncluded)}
            />
            
            {renderStandardReportFormFields(fields, form)}
            
            <CommonButton
              size="large"
              endIcon={<ArrowRightIcon />}
              label={getLabelForNextButton(dateRangeValue, classes)}
              className={classNames(classes.rangeButton, classes.rangeButtonNext)}
              onClick={() => updateDateRangeFields('next', values, setFieldValue, validateForm, dateRangeValue, isTimeIncluded)}
            />
          </div>
          
          <div className={classes.buttonWrapper}>
            <CommonButton
              isAnimated
              onClick={() => isValid && submitForm()}
              size="large"
              label={
                <FormattedMessage
                  id="search"
                  defaultMessage="Search"
                />}
              disabled={isSubmitting || !values.machineIDs || !values.dateFrom || !values.dateTo || !isValid}
            />
          </div>
          <CommonDivider />
        
        </Form>
      );
    }}
  </Formik>;
};

StandardReportForm.propTypes = {
  fields: PropTypes.array,
  fetchStandardReports: PropTypes.func,
  setFormValues: PropTypes.func,
  machines: PropTypes.array,
  classes: PropTypes.object,
  reportName: PropTypes.string,
  salesStartTime: PropTypes.object,
  fetchBusinessSalesStart: PropTypes.func,
};

const decorate = compose(
  withStyles(styles),
  connect(store => ({ machines: store.user.machines, salesStartTime: store.user.salesStartTime }),
    dispatch => bindActionCreators({ fetchStandardReports, fetchBusinessSalesStart }, dispatch)),
);

export default decorate(StandardReportForm);